<template>
  <div class="home" id="home">
    <Navbar></Navbar>    
    <!--START BANNER DESKTOP-->
    <div class="banner menu-md">
      <div class="img-background">           
          <div class="row"> 
            <div class="col-md-12 text-center">
              <a href="http://www.editoradobrasil.com.br/faleconosco/" target="_blank" class="btn btn-about" role="button" aria-pressed="true">DÚVIDAS? FALE CONOSCO</a> 
              <div class="img-banner"></div>        
            </div>
          </div>
       
      </div>  
    </div>
    <div class="menu-md">
        <div class="text-banner">
          <div class="container">
            <div class="row justify-content-center"> 
              <div class="col-md-9 text-center">
                A coleção mais querida do Brasil, traz um conteúdo trabalhado através de cores e brincadeiras, possibilitando um aprendizado divertido e prazeroso.
              </div>
          </div> 
        </div>
      </div>
    </div>
    <!--END BANNER DESKTOP--> 
    <!--START BANNER MOBILE--> 
    <div class="banner-mobile menu-sm">    
        <a href="http://www.editoradobrasil.com.br/faleconosco/" target="_blank" class="btn btn-about" role="button" aria-pressed="true">DÚVIDAS? FALE CONOSCO</a>            
        <div class="img-banner"></div>    
      <div class="text-banner-mobile">
        <div class="col text-center">
          A coleção mais querida do Brasil, traz um conteúdo trabalhado através de cores e brincadeiras, possibilitando um aprendizado divertido e prazeroso.
        </div>
      </div>  
    </div>
    <!--END BANNER MOBILE-->    
    <!--STRAT TRACK  BALL-->     
    <div class="row menu-md">
      <div class="track-ball"></div>
    </div>   
    <div class="track-ball-mobile menu-sm"> </div>
    <!--END TRACK  BALL-->
    <!--STRAT CAROUSEL-->
    <div class="container book menu-md">      
      <div class="row justify-content-center">
        <div class="col-md-10">
          <VueSlickCarousel v-bind="settingsBook">          
            <div class="">
              <a href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/tic-tac/ei1/index.html" target="_black"><img src="../assets/capas/tic-tac-1.png" class="img-fluid  mx-auto"></a>
            </div>
            <div class="">
              <a href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/tic-tac/ei2/index.html" target="_black"><img src="../assets/capas/tic-tac-2.png" class="img-fluid  mx-auto"></a>
            </div>
            <div class="">
              <a href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/tic-tac/ei3/index.html" target="_black"><img src="../assets/capas/tic-tac-3.png" class="img-fluid  mx-auto"></a>
            </div>    
            <div class="">
              <a href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/tic-tac/meu-primeiro-livro/index.html" target="_black"><img src="../assets/capas/tic-tac-meu-primeiro-livro.png" class="img-fluid mx-auto m-pl"></a>
            </div>            
          </VueSlickCarousel> 
          <div id="leb"></div> 
        </div>
      </div>
    </div>
    <div class="book menu-sm">      
      <div class="row justify-content-center">
        <div class="col-md-10">
          <VueSlickCarousel v-bind="settingsBook">          
            <div class="">
              <a href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/tic-tac/ei1/index.html" target="_black"><img src="../assets/capas/tic-tac-1.png" class="img-fluid  mx-auto"></a>
            </div>
            <div class="">
              <a href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/tic-tac/ei2/index.html" target="_black"><img src="../assets/capas/tic-tac-2.png" class="img-fluid  mx-auto"></a>
            </div>
            <div class="">
              <a href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/tic-tac/ei3/index.html" target="_black"><img src="../assets/capas/tic-tac-3.png" class="img-fluid  mx-auto"></a>
            </div>    
            <div class="">
              <a href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/tic-tac/meu-primeiro-livro/index.html" target="_black"><img src="../assets/capas/tic-tac-meu-primeiro-livro.png" class="img-fluid mx-auto m-pl"></a>
            </div>            
          </VueSlickCarousel> 
          <div id="leb"></div> 
        </div>
      </div>
    </div>
    <!--FIM CAROUSEL-->  
    <div class="container">      
      <div class="row"> 
         <div class="text-middle text-center">     
            <div class="col-md-10 offset-md-1 text-green">
              Todo conteúdo digital em um só lugar 
            </div>
            <div class="row">
              <div class="col-md-10 offset-md-1 text-center text-grey">
                A Coleção tem conteúdos e ferramentas digitais disponíveis no Laboratório Educacional Brasil (LEB), 
                um ambiente virtual especialmente elaborado para proporcionar uma experiência dinâmica e transformadora com o conhecimento.
              </div>
              <div class="col-md-12 text-center menu-md">
                <a href="https://www.editoradobrasil.com.br/leb" target="_blank"><img src="../assets/logos/logo-leb.png" class="img-fluid"></a>
              </div>
              <div class="col menu-sm">
                 <a href="https://www.editoradobrasil.com.br/leb" target="_blank"><img src="../assets/logos/logo-leb.png" class="leb-bottom"></a>
              </div>
              <div class="container"> 
                <div class="row">
                  <div class="col-md-3">
                    <div class="img-menino menu-md">
                      <img src="../assets/imagens/boy-bird.png" class="img-fluid">
                    </div>
                  </div>
                  <div class="col-md-7">
                     <div class="text-green-bird text-center">
                      Principais recursos digitais para aluno e Professor
                      </div>
                      <div class="text-grey-bird">
                        Materiais alinhados à Base Nacional Comum Curricular (BNCC) e ferramentas digitais que colaboram com o processo de aprendizagem em sala de aula.
                      </div> 
                      <div class="img-bncc"> </div>  
                  </div>                                 
                </div>
              </div> 
          </div>          
        </div>
      </div>
    </div>
    <!-- RECURSOS DIGITAIS -->
    <div class="recursos-digitais">
      <div class="container">
        <div class="row">
          <div class="col-md-12 text-center hide-sm">
            <h3 style="color: #71C043;">Recursos Digitais</h3>
          </div>
          <div class="col-md-11 offset-md-1 text-left">
            <h1 style="margin-bottom: 16px" class="star"><img src="../assets/icons/Icon-material-stars-1.png" class="img-fluid space img-star">Professor</h1>
          </div>       
          <div class="col-md-5 offset-md-1 menu-md">
              <img src="../assets/imagens/professor.png" class="img-fluid img-star"> 
          </div>
          <div class="col-md-5">
            <div class="box">
              <div class="lista">
                <ul class="list-unstyled">
                  <li>Atividades interativas</li> 
                  <li>Atividades extras</li> 
                  <li>Banco de brincadeiras e brinquedos regionais</li> 
                  <li>Banco de dobraduras</li> 
                  <li>Livro Digital</li> 
                  <li>Projetos literários</li> 
                  <li>Projetos integradores</li> 
                  <li>Planejador de aulas</li> 
                  <li>Sequências Didáticas - Isto pode virar aula</li> 
                  <li>Vídeos com parlendas</li> 
                  <li>Videotutoriais a respeito dos 5 campos de experiência da BNCC</li> 
                  <li>Vídeos com contação de histórias</li>
                </ul>
              </div>
              <a href="https://www.editoradobrasil.com.br/leb" target="_blank">Acessar a plataforma <img src="../assets/icons/Icon-feather-mouse-pointer.png" class="img-fluid"></a>
            </div>
          </div> 
          <div class="col-md-11 offset-md-1 text-left">
            <h1 style="margin-bottom: 16px" class="star"><img src="../assets/icons/Icon-material-stars-1.png" class="img-fluid space img-star">Aluno</h1>
          </div>       
          <div class="col-md-5 offset-md-1 menu-md">
              <img src="../assets/imagens/aluno.png" class="img-fluid"> 
          </div>
          <div class="col-md-5">
            <div class="box">
              <div class="lista">
                <ul class="list-unstyled">
                  <li>Atividades interativas</li>
                    <li>Atividades extras</li> 
                    <li>Banco de brincadeiras e brinquedos regionais</li> 
                    <li>Banco de dobraduras</li> 
                    <li>Livro Digital</li> 
                    <li>Vídeos com contação de histórias</li>
                </ul>             
              </div>           
              <a href="https://www.editoradobrasil.com.br/leb" target="_blank">Acessar a plataforma <img src="../assets/icons/Icon-feather-mouse-pointer.png" class="img-fluid"></a>
              <div id="destaques"> </div>
            </div>            
          </div>
        </div>
      </div>
    </div>
    <!--Destaques -->
    <div class="destaque" >
        <div class="fundo-azul" >
          <div class="row justify-content-center menu-md">
            <div class="col-md-2 offset-md-1">
              <img src="../assets/imagens/destaques-01.png" class="img-fluid"> 
            </div>
            <div class="col-md-5 text-center">
              <h1>Destaques da obra</h1>
            </div>
            <div class="col-md-2 offset-md-1">
            <img src="../assets/imagens/bird.png" class="img-fluid"> 
            </div>         
          </div>
          <div class="col-md-5 text-center menu-sm">
            <img src="../assets/imagens/bird.png" class="img-fluid"> 
            <h1>Destaques da obra</h1>
          </div>
          <div class="row justify-content-center">
            <div class="col-md-10 align">
              <div class="container">
              <VueSlickCarousel v-bind="settingsdestaques">
                <div class="position-slider">
                  <div class="img-box"></div>
                    <div class="text-slider">
                      <div class="container">
                        <div class="row">
                          <div class="menu-md">
                            <img src="../assets/icons/icon-material-stars.png" class="img-fluid img-star">                              
                          </div>
                          <div class="col menu-sm">                            
                            <h2><div class="img-star"></div>DESENVOLVIMENTO</h2>
                          </div>
                          <div class="col menu-md">
                            <h2>DESENVOLVIMENTO</h2>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col">
                            <p>Traz diferentes propostas que incentivam a
                              participação das crianças e promovem o
                              desenvolvimento (cognitivo, afetivo e
                              social), estimulam a criatividade e
                              contribuem na construção da identidade e
                              na formação cidadã;</p>
                          </div>                        
                        </div>
                      </div>
                    </div>
                </div>
                <div class="position-slider">
                  <div class="img-box"></div>
                    <div class="text-slider">
                      <div class="container">
                        <div class="row">
                          <div class="menu-md">
                            <img src="../assets/icons/icon-material-stars.png" class="img-fluid img-star">                              
                          </div>
                          <div class="col menu-sm">                            
                            <h2 class="h2"><div class="img-star"></div>HABILIDADES</h2>
                          </div>
                          <div class="col menu-md">
                            <h2>HABILIDADES</h2>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col">
                            <p class="p-bottom">Trabalha habilidades motoras, cognitivas e
                              <br/>sensoriais - possibilitando ao aluno um
                              desenvolvimento mais amplo e
                              abrangente.</p>
                          </div>                        
                        </div>
                      </div>
                    </div>
                </div>           
                <div class="position-slider">
                  <div class="img-box"></div>
                    <div class="text-slider">
                      <div class="container">
                        <div class="row">
                          <div class="menu-md">
                            <img src="../assets/icons/icon-material-stars.png" class="img-fluid img-star">                              
                          </div>
                          <div class="col menu-sm">                            
                            <h2 class="h2"><div class="img-star"></div>PROPOSTAS</h2>
                          </div>
                          <div class="col menu-md">
                            <h2>PROPOSTAS</h2>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col">
                            <p class="p-bottom">As propostas estão pautadas em
                              diferentes gêneros textuais, como trava-
                              línguas, parlendas, cantigas, adivinhas,
                              letras de músicas e apoemas;</p>
                          </div>                        
                        </div>
                      </div>
                    </div>
                </div>
              </VueSlickCarousel> 
              </div>
              <div id="autoras"></div>
            </div>
          </div>
        </div>
        <div class="img-cloud"></div>
    </div>
    <!--Autora -->
    <div class="autora">
      <div class="faixa text-center menu-md">
        <div class="container">
          <div class="row">
            <div class="offset-md-3 col-md-1 img-dentes">
              <img src="../assets/imagens/destaques-01.png" class="img-fluid"> 
            </div>
            <div class="col-md-2 offset-md-1">
                <h1>Autora</h1>
            </div>
            <div class="col-md-5">
              <img src="../assets/imagens/autora.png" class="img-fluid img-menina"> 
            </div>
          </div>
        </div>
      </div>
      <div class="container menu-md">
        <div class="row">
          <div class="col-md-10 offset-md-1 text-center">
            <div class="linepurple"></div>
          </div>     
        </div>
      </div>
 
      <div class="col menu-sm text-center">
        <h1>Autora</h1>
      </div>   
      <div class="container">
        <div class="row">
          <div class="col-md-5 offset-md-1">
            <img src="../assets/imagens/imag-autora.png" class="img-fluid"> 
          </div>
          <div class="col-md-5">
            <h2>Vilza Carla</h2>
            <ul>
              <li><p>Formada em Pedagogia com habilitação em Orientação Educacional.</p></li>
              <li><p>Pós-graduada em Psicopedagogia.</p></li>
              <li><p>Vários anos de experiência no trabalho com crianças em escolas das redes particular e pública da Educação Infantil e do Ensino Fundamental I.</p></li>
              <li><p>Autora da Coleção Tic-tac – É Tempo de Aprender (versão integrada e versão seriada), da Editora do Brasil, destinada a crianças da Educação Infantil.</p></li>
              <li><p>Coautora da Coleção Essa Mãozinha Vai Longe – Caligrafia, da Editora do Brasil, destinada a crianças da Educação Infantil e do Ensino Fundamental (1º ao 5º ano).</p></li>
            </ul>
          </div>        
        </div>
      </div>   
    </div>
    <!-- Footer -->
    <Footer></Footer>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'

export default {
  name: 'Home',
  components: {
    Navbar, Footer, VueSlickCarousel 
  },
  data(){
    return{
      settingsBook: {
          "dots": false,
          "arrows": true,
          "focusOnSelect": true,
          "infinite": true,
          "speed": 500,
          "slidesToShow": 3,
          "slidesToScroll": 1,
          "touchThreshold": 1,           
          "variableWidth": true,      
          "responsive": [
          {
            "breakpoint": 1025,
            "settings": {
            "slidesToShow": 3,
            "slidesToScroll": 1,          
            "dots": false,
            "touchMove": true,
            "arrows": false, 
            "variableWidth": true,
            "infinite": true,
            }
          },
          {
            "breakpoint": 790,
            "settings": {
            "slidesToShow": 2,
            "slidesToScroll": 1,          
            "arrows": false,            
            "touchMove": true,
            "variableWidth": true,                
            }
          },
          {
            "breakpoint": 480,
            "settings": {
            "initialSlide": 1,
            "slidesToShow": 1,
            "slidesToScroll": 1,
            "arrows": false,
            "touchMove": true,
            "variableWidth": true
            }
          }
        ]
      },
      settingsdestaques:{
          "dots": false,
          "arrows": true,        
          "infinite": true,
          "speed": 500,
          "slidesToShow": 2,
          "slidesToScroll": 1,
          "touchThreshold": 1,
          "responsive": [
          {
            "breakpoint": 1025,
            "settings": {        
            "slidesToShow": 2,
            "slidesToScroll": 1,
            "touchThreshold": 1,       
            "dots": false,
            "arrows": false,
            "infinite": true,
            "touchMove": true,         
            }
          },
          {
            "breakpoint": 790,
            "settings": {
            "slidesToShow": 2,
            "slidesToScroll": 1,
             "touchThreshold": 1,               
            "arrows": false,
            "touchMove": true
            }
          },
          {
            "breakpoint": 480,
            "settings": {
            "slidesToShow": 1.06,
            "slidesToScroll": 1,
            "arrows": false,
            "touchMove": true,       
            "infinite": true,
            "centerMode": true,
            "centerPadding": "5%"            
            }
          }
        ]
      }
    }
  }
}
</script>

